import React, { useState, useEffect } from "react";
import {
  Divider,
  Icon,
  Button,
  Dropdown,
  Segment,
  GridRow,
  GridColumn,
  Grid,
  Loader,
  Message,
  Table,
  Label,
} from "semantic-ui-react";
import {
  Dangerousform,
  Effluentform,
  Energyform,
  KPIsform,
  Permission,
  Productionform,
  Site,
  Socialform,
  Wasteform,
  Waterform,
 // AirEmissionsform
 Fuelsform,
 Form as FormApi,
} from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { ErrorAccessDenied } from "../../../../pages/admin/Error";
import { reportExcel } from "../ExcelReport";
import { reportPdfByYear } from "../PdfReport";
import { jsPDF } from "jspdf";
import { FORMS, MODULES } from "../../../../utils";
import { convertFormsEngToEsp } from "../../../../utils/converts";
import { useLocation } from "react-router-dom";
import "./ViewReport.scss";
import { useLanguage } from "../../../../contexts";
import { useCompany } from "../../../../contexts/CompanyContext";
import {
  dangerousCodes,
  effluentCodes,
  fuelsCodes,
  kpisCodes,
  productionCodes,
  socialCodes,
  wasteCodes,
  waterCodes,
} from "../../../../utils/codes";
import { energyCodes } from "../../../../utils/dataAndFormulas/energyForms";
const _ = require("lodash");

const MODULE_META = {
  social:     { icon: "users",              description: "Trabajadores, accidentes y formación",              color: "blue"   },
  energy:     { icon: "lightning",          description: "Electricidad, gas, vapor y energías renovables",   color: "yellow" },
  effluent:   { icon: "recycle",            description: "Efluentes domésticos e industriales",              color: "teal"   },
  water:      { icon: "tint",              description: "Consumo de agua por fuente y tipo",                color: "blue"   },
  waste:      { icon: "trash alternate",    description: "Residuos sólidos peligrosos y no peligrosos",      color: "brown"  },
  fuel:       { icon: "fire",              description: "Gas, gasoil, nafta y otros combustibles",          color: "orange" },
  production: { icon: "industry",          description: "Volumen de producción mensual",                    color: "grey"   },
  kpis:       { icon: "chart bar",         description: "Indicadores clave de desempeño ambiental",         color: "purple" },
  dangerous:  { icon: "warning sign",      description: "Gestión y tratamiento de residuos peligrosos",     color: "red"    },
};

const getCodeKeys = (mod) => {
  switch (mod) {
    case "social":      return socialCodes;
    case "energy":      return energyCodes;
    case "effluent":    return effluentCodes;
    case "water":       return waterCodes;
    case "waste":       return wasteCodes;
    case "fuel":        return fuelsCodes;
    case "production":  return productionCodes;
    case "kpis":        return kpisCodes;
    case "dangerous":   return dangerousCodes;
    default:            return {};
  }
};

const permissionController = new Permission();
const waterFormController = new Waterform();
const wasteFormController = new Wasteform();
const productionFormController = new Productionform();
const socialFormController = new Socialform();
const energyFormController = new Energyform();
const effluentController = new Effluentform();
const dangerousController = new Dangerousform();
const kpisController = new KPIsform();
const siteController = new Site();
//const airEmissionController = new AirEmissionsform();
const fuelsController = new Fuelsform();
const formApiController = new FormApi();

// Mapeo de moduleSelected → nombre del form en BD
const MODULE_TO_FORM_NAME = {
  social: "social",
  energy: "energy",
  water: "water",
  fuel: "fuels",
  effluent: "effluent",
  waste: "waste",
  production: "production",
};


export function ViewReports(props) {
  const [permissions, setPermissions] = useState([]);
  const [moduleSelected, setModuleSelected] = useState(null);
  const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
  const [siteSelected, setSiteSelected] = useState(null);
  const [listModules, setListModules] = useState([]);
  const [listSites, setListSites] = useState([]);
  const [data, setData] = useState([]);
  const [buttonAvailable, setButtonAvailable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [configFormData, setConfigFormData] = useState(null);
  const [siteNameSelected, setSiteNameSelected] = useState("");

  // const [Role, setRole] = useState(null);
  const {
    user: { role, company, site },
    accessToken,
  } = useAuth();

  const { translations } = useLanguage();
  const { company: companyCtx } = useCompany();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const [column, setColumn] = useState(null);
  //const [data, setData] = useState(/* Your data array */);
  const [direction, setDirection] = useState(null);
  const location = useLocation();

  useEffect(() => {
    (async () => {
      try {
        let newList = [];
        FORMS.map((form) => {
          newList.push(form);
          return true;
        });
        setListModules(newList);
      } catch (error) {
        // console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (!site && !location.state?.siteSelected) {
          const response = companyCtx
            ? await siteController.getSitesByCompany(accessToken, companyCtx, true)
            : await siteController.getSites(accessToken);
          setListSites(response);
          setSiteSelected(null);
        } else if (site) {
          setSiteSelected(site);
          try {
            const siteData = await siteController.getSite(accessToken, site);
            if (siteData?.name) setSiteNameSelected(siteData.name);
          } catch (_) {}
        }
      } catch (error) {
        setListSites([]);
      }
    })();
  }, [companyCtx]);

  useEffect(() => {
    (async () => {
      setConfigFormData(null);
      if (siteSelected && moduleSelected && MODULE_TO_FORM_NAME[moduleSelected]) {
        try {
          const response = await formApiController.getFormsBySite(
            accessToken,
            siteSelected,
            MODULE_TO_FORM_NAME[moduleSelected]
          );
          if (response && response.length > 0) {
            setConfigFormData(response[0]);
          }
        } catch (error) {
          // sin configForm, se mostrarán todos los campos
        }
      }
    })();
  }, [siteSelected, moduleSelected]);

  useEffect(() => {
    (async () => {
      try {
        setData([]);
        setHasSearched(false);
        if (yearSelected && moduleSelected !== null && siteSelected !== null) {
          setButtonAvailable(true);
          setLoading(true);
          moduleConsult(moduleSelected);
        }
      } catch (error) {
        // console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [moduleSelected, yearSelected, siteSelected]);

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  const getWaterForm = async () => {
    try {
      const response = await waterFormController.getWaterFormsBySiteAndYear(
        accessToken,
        siteSelected,
        yearSelected
      );
      if (response.code === 200) {
        setData(response.waterForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const getProductionForm = async () => {
    try {
      const response =
        await productionFormController.getProductionFormsBySiteAndYear(
          accessToken,
          siteSelected,
          yearSelected
        );
      if (response.code === 200) {
        setData(response.productionForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const getSocialForm = async () => {
    try {
      const response = await socialFormController.getSocialFormsBySiteAndYear(
        accessToken,
        siteSelected,
        yearSelected
      );
      if (response.code === 200) {
        setData(response.socialForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const getEnergyForm = async () => {
    try {
      const response = await energyFormController.getEnergyFormsBySiteAndYear(
        accessToken,
        siteSelected,
        yearSelected
      );
      if (response.code === 200) {
        setData(response.energyForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const getDangerousForm = async () => {
    try {
      const response = await dangerousController.getDangerousFormsBySiteAndYear(
        accessToken,
        siteSelected,
        yearSelected
      );
      if (response.code === 200) {
        setData(response.dangerousForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const getEffluentForm = async () => {
    try {
      const response = await effluentController.getEffluentFormsBySiteAndYear(
        accessToken,
        siteSelected,
        yearSelected
      );
      if (response.code === 200) {
        setData(response.effluentForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const getKPIsForm = async () => {
    try {
      const response = await kpisController.getKPIsFormsBySiteAndYear(
        accessToken,
        siteSelected,
        yearSelected
      );
      if (response.code === 200) {
        setData(response.kpisForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const getWasteForm = async () => {
    try {
      const response = await wasteFormController.getWasteFormsBySiteAndYear(
        accessToken,
        siteSelected,
        yearSelected
      );
      if (response.code === 200) {
        setData(response.wasteForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  {/*const getAirEmissionForm = async () => {
    const response = await airEmissionController.getAirEmissionsFormsBySiteAndYear(
      accessToken,
      siteSelected,
      yearSelected
    );
    if (response.code === 200) {
      setData(response.airEmissionsForms);
      setButtonAvailable(false);
    } else {
      setData([]);
    }
  };*/}
  const getFuelsForm = async () => {
    try {
      const response = await fuelsController.getFuelsFormsBySiteAndYear(
        accessToken,
        siteSelected,
        yearSelected
      );
      if (response.code === 200) {
        setData(response.fuelsForms);
        setButtonAvailable(false);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const moduleConsult = (a) => {
    switch (a) {
      case "social":
        return getSocialForm();
      case "energy":
        return getEnergyForm();
      case "production":
        return getProductionForm();
      case "effluent":
        return getEffluentForm();
      case "water":
        return getWaterForm();
      case "waste":
        return getWasteForm();
      case "kpis":
        return getKPIsForm();
      case "dangerous":
        return getDangerousForm();
     {/* case "airemissions":
        return getAirEmissionForm();*/}
        case "fuel":
        return getFuelsForm();
      default:
        return null;
    }
  };

  const handleSort = (clickedColumn) => () => {
    if (column !== clickedColumn) {
      setColumn(clickedColumn);
      setData(
        [...data].sort((a, b) => (a[clickedColumn] > b[clickedColumn] ? 1 : -1))
      );
      setDirection("ascending");
      return;
    }

    setData(data.reverse());
    setDirection(direction === "ascending" ? "descending" : "ascending");
  };

  const generateExcel = (data, moduleSelected, yearSelected, t) => {
    return reportExcel(data, moduleSelected, yearSelected, t, configFormData, siteNameSelected);
  };

  const previewFields = moduleSelected
    ? Object.keys(getCodeKeys(moduleSelected)).slice(0, 4)
    : [];

  const data2 = [
    { id: 1, name: "John Doe", age: 30, profession: "Developer" },
    { id: 2, name: "Jane Smith", age: 25, profession: "Designer" },
  ];

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  if (
    isMaster(role) ||
    isAdmin(role) ||
    hasPermission(permissionsByRole, role._id, "reports", "view")
  ) {
    // if (!listRoles) return <Loader active inline="centered" />;
    // if (size(listRoles) === 0) return "No hay ningun rol";
    return (
      <div className="form-report">
        <div></div>

        <Segment className="report-segment">
          {!site ? (
            <div className="report-controls-row" style={{ marginBottom: "12px" }}>
              <div className="report-control-field">
                <label>{t("site")}</label>
                <Dropdown
                  placeholder={t("select")}
                  options={listSites.map((ds) => ({
                    key: ds._id,
                    text: ds.name,
                    value: ds._id,
                  }))}
                  selection
                  onChange={(_, data) => {
                    setSiteSelected(data.value);
                    const found = listSites.find((s) => s._id === data.value);
                    setSiteNameSelected(found?.name || "");
                  }}
                  value={siteSelected}
                />
              </div>
            </div>
          ) : null}

            <Divider />

          {/* {siteSelected && siteSelected !== null ? ( */}
            <>
              {/* Fila principal: dropdowns + botones */}
              <div className="report-controls-row">
                <div className="report-control-field">
                  <label>{t("data")}</label>
                  <Dropdown
                    placeholder={t("select")}
                    options={listModules.map((ds) => ({
                      key: ds,
                      text: t(ds),
                      value: ds,
                    }))}
                    selection
                    onChange={(_, data) => setModuleSelected(data.value)}
                    value={moduleSelected}
                  />
                </div>

                <div className="report-control-field">
                  <label>{t("year")}</label>
                  <Dropdown
                    placeholder={t("select")}
                    options={years.map((ds) => ({
                      key: ds,
                      text: ds,
                      value: ds,
                    }))}
                    selection
                    onChange={(_, data) => setYearSelected(data.value)}
                    value={yearSelected}
                  />
                </div>

                <div className="report-btn-group">
                  <Button
                    className="btn-pdf"
                    disabled={buttonAvailable}
                    onClick={() => reportPdfByYear(data, moduleSelected, yearSelected, t, configFormData, siteNameSelected)}
                  >
                    {t("download")} PDF
                  </Button>

                  <Button
                    className="btn-excel"
                    disabled={buttonAvailable}
                    onClick={() => generateExcel(data, moduleSelected, yearSelected, t)}
                  >
                    {t("download")} xlsx
                  </Button>
                </div>
              </div>

              {/* Indicador de módulo */}
              {/* {moduleSelected && MODULE_META[moduleSelected] && (
                <div style={{ marginTop: "10px", marginLeft: "4px" }}>
                  <Label color={MODULE_META[moduleSelected].color} basic>
                    <Icon name={MODULE_META[moduleSelected].icon} />
                    {MODULE_META[moduleSelected].description}
                  </Label>
                </div>
              )} */}

              {/* <Divider /> */}

              {/* Loading */}
              {loading && (
                <Segment basic textAlign="center" style={{ padding: "2em 0" }}>
                  <Loader active inline="centered" content="Cargando datos..." />
                </Segment>
              )}

              {/* Sin datos */}
              {!loading && hasSearched && data.length === 0 && (
                <Message info compact size="small">
                  <Icon name="info circle" />
                  Sin datos disponibles para el período y fuente seleccionados.
                </Message>
              )}

              {/* Datos encontrados: mensaje de éxito */}
              {!loading && data.length > 0 && (
                <Message positive compact size="small">
                  <Icon name="check circle" />
                  <strong>{data.length}</strong>{" "}
                  {data.length === 1 ? "registro encontrado" : "registros encontrados"}
                  {" — "}listo para descargar
                </Message>
              )}

              {/* Vista previa — comentado temporalmente */}
              {/* {!loading && data.length > 0 && (
                <>
                  <Divider horizontal>
                    <span style={{ color: "#888", fontSize: "0.85em" }}>
                      Vista previa (primeros {Math.min(data.length, 5)} de {data.length})
                    </span>
                  </Divider>

                  <div style={{ overflowX: "auto" }}>
                    <Table compact celled size="small" striped>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>{t("period")}</Table.HeaderCell>
                          {previewFields.map((f) => (
                            <Table.HeaderCell key={f}>{t(f)}</Table.HeaderCell>
                          ))}
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {data.slice(0, 5).map((row, i) => (
                          <Table.Row key={i}>
                            <Table.Cell>{t(row.period)}</Table.Cell>
                            {previewFields.map((f) => (
                              <Table.Cell key={f} textAlign="center">
                                {row[f]?.value != null
                                  ? `${row[f].value}${row[f].unit ? " " + row[f].unit : ""}`
                                  : "-"}
                              </Table.Cell>
                            ))}
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </div>

                  {data.length > 5 && (
                    <p style={{ color: "#888", textAlign: "center", fontSize: "0.85em", marginTop: "4px" }}>
                      ... y {data.length - 5} registros más en el archivo descargado
                    </p>
                  )}
                </>
              )} */}
            </>
          {/* ) : null} */}
        </Segment>
        <div></div>
      </div>
    );
  } else {
    return <ErrorAccessDenied />;
  }
}
